<template>
	<div v-show="bodyIsShow">
		<div class="bodywrap">
	   		<section>
				<div class="sucmsg">
					<div class="tit">
						<em class="icon"></em>报名成功
					</div>
	   	  	 		<p class="hint">请保持手机畅通，稍后会有团车网工作人员与您联系确认门票领取事宜</p>
					<div class="imgwrap">
							<!--<div class="eCoder">
								
							</div>-->
							<img :src="commmonWebConfig.webCommonUtils+'/img/common/logo02.png'" />
							<!--<img :src="pathWebCommonUtils+'/img/common/logo02.png'" />-->
					</div>
	         		<p class="addred" style="padding-bottom:0.266666rem;">微信识别二维码或添加
	                    <span>“团车网”公众号</span>领票
	                </p>
					<div class="telphone">
						<div class="redsize"><em></em>官方服务热线：<a class="size-black" href="tel:4001-501-501">4001-501-501</a></div>
						<div class="timer">服务时间：9:00-18:00</div>
	                </div>
				</div>
			</section>
			<section>
				<div class="whyselect clearfix">
	                <div class="line1"></div>为什么选择团车网<div class="line2"></div>
					<div class="pldge-wrap clearfix">
						<div class="promise1 promise  bigline btnline">
							<em class="icon01"></em>
	                      	<div class="rightbox">
								<div class="title">积淀深厚</div>
	                          	<div class="center">成立于2009年</div>
	                          	<div class="size-btn">为用户节省11亿元</div>
	                      	</div>
	                  	</div>
	                    <div class="promise2 promise btnline">
							<em class="icon02"></em>
							<div class="rightbox">
								<div class="title">覆盖全面</div>
								<div class="center">全国30个服务网点</div>
								<div class="size-btn">覆盖50个品牌</div>
							</div>
						</div>
	                    <div class="promise3 promise bigline">
							<em class="icon03"></em>
							<div class="rightbox">
	                           	<div class="title">车源优质</div>
	                           	<div class="center">正规厂家4s店合作</div>
	                           	<div class="size-btn">提供优质车源</div>
							</div>
	                    </div>
	                    <div class="promise4 promise">
							<em class="icon04"></em>
							<div class="rightbox">
	                           	<div class="title">价格保障</div>
	                           	<div class="center">全国范围询价</div>
	                           	<div class="size-btn">确保低价</div>
							</div>
	                    </div>
					</div>
				</div>
			</section>
	    </div>
	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";
	
	
</style>
<script>
//import msg from "@/data/dataSuc.js";
export default {
	name: 'perfect',
	data:function() {
		return {
			bodyIsShow:false,
			applyId:14195215,
			periods:{
				successBannerList:[],
				// 已使用真实数据
				successBannerCb:true,
				// 已使用真实数据
				qrcodeImg:"",
				// 已使用真实数据
				weixinNickname:"",
				// 已使用真实数据
				weixin:"",
				picUrl:""
			}
		}
	},
	beforeCreate:function(){
		getCommonJsIns.initCSS({
			cssURL:"/css/carfestival/suc.css"
		});
	},
	mounted:function(){
		var self = this;
		document.title="报名成功";
		this.bodyIsShow = true;
	}
}
</script>


// WEBPACK FOOTER //
// src/views/toutiao/success.vue